module.exports = __webpack_public_path__ + "static/media/dagger-uncommon.784b4261.png";